export const DSControlledDateTimePickerName = 'DSControlleddatetimepicker';

export const DSControlledDateTimePickerSlots = {
  CONTAINER: 'root',
  INPUT: 'field-input',
  DATE_INPUTS: {
    MONTH: 'ds-controlled-date-time-picker-month-input',
    DAY: 'ds-controlled-date-time-picker-day-input',
    YEAR: 'ds-controlled-date-time-picker-year-input',
  },
  TIME_INPUTS: {
    HOUR: 'ds-controlled-date-time-picker-hour-input',
    MINUTE: 'ds-controlled-date-time-picker-minute-input',
    MERIDIEM: 'ds-controlled-date-time-picker-meridiem-input',
  },
  PICKER_ICONS: {
    CALENDAR: 'calendar-trigger-icon',
    TIMEWHEEL: 'timewheel-trigger-icon',
    CALENDAR_TIMEWHEEL: 'calendar-timewheel-trigger-icon',
  },
  CALENDAR: {
    DAY_BUTTON: 'calendar-day',
    HEADER_LABEL: 'calendar-header-label',
    HEADER_BUTTON: 'calendar-header-buttons',
    HEADER_WEEKLY_DAY_LIST: 'calendar-header-weekly-day-list',
  },
  TIMEWHEEL: {
    TIME_BUTTON: 'timewheel-time-button',
    TIME_CHANGE_BUTTON: 'timewheel-time-change-button',
    HEADER_LABEL: 'timewheel-header-label',
  },
  CONTEXTUAL_MENU: {
    CALENDAR: 'calendar-context-content-wrapper',
    TIMEWHEEL: 'timewheel-context-content-wrapper',
    CALENDAR_TIMEWHEEL: 'calendar-timewheel-context-content-wrapper',
  },
  FOOTERS: {
    CALENDAR: 'calendar-context-footer',
    TIMEWHEEL: 'timewheel-context-footer',
    CALENDAR_TIMEWHEEL: 'calendar-timewheel-context-footer',
  },
  CONTROLLER_COMPONENT: {
    CALENDAR: 'calendar-controller-wrapper',
    TIMEWHEEL: 'timewheel-controller-wrapper',
    CALENDAR_TIMEWHEEL: 'calendar-timewheel-controller-wrapper',
  },
  CLEAR_BUTTON: 'clear-btn',
};
